import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { MdArrowBack, MdPhone, MdEmail, MdLocationOn } from 'react-icons/md';
import { LanguageSelector, useLanguage } from '../i18n';
import { API_BASE, withSystem, SYSTEM_SLUG } from './publicApi';

// Moved off the homepage (PublicBooking.js) so the homepage itself stays a
// short, two-screen scroll. This page carries the same contact-info cards
// that used to live in a <section id="contact"> there.
export default function ContactPage() {
    const { t } = useLanguage();
    const [homepage, setHomepage] = useState(null);
    const ownSystem = !!SYSTEM_SLUG;   // organizations show only what they wrote

    useEffect(() => {
        axios.get(`${API_BASE}/homepage`, { params: withSystem() }).then(response => {
            setHomepage(response.data);
        }).catch(() => { });
    }, []);

    return (
        <div style={{ minHeight: '100vh', background: '#fff', fontFamily: "'Inter',-apple-system,sans-serif" }}>
            <nav style={{
                background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 5%', height: 68,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                position: 'sticky', top: 0, zIndex: 200, boxShadow: '0 1px 8px rgba(0,0,0,0.06)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <img src={homepage?.logo_url || '/logo512.png'} alt={`${homepage?.system_name || 'MITI FMS'} ${t('contact.logoAlt')}`} style={{ width: 38, height: 38, borderRadius: 9, objectFit: 'cover' }} />
                    <div>
                        <div style={{ fontWeight: 800, fontSize: 17, color: '#0f172a', lineHeight: 1 }}>{homepage?.system_name || 'MITI FMS'}</div>
                        {!ownSystem && <div style={{ fontSize: 10, color: '#94a3b8', letterSpacing: '0.5px' }}>{t('contact.facilityManagementLabel')}</div>}
                    </div>
                </div>
                <div style={{ display: 'flex', gap: 14, alignItems: 'center' }}>
                    <LanguageSelector style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 999, padding: '4px 8px' }} />
                    <a href="/" style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#2563eb', fontWeight: 600, textDecoration: 'none', border: '1.5px solid #2563eb', padding: '7px 16px', borderRadius: 8 }}>
                        <MdArrowBack size={15} /> {t('contact.backToHome')}
                    </a>
                </div>
            </nav>

            <section style={{ padding: '64px 5% 80px', background: 'linear-gradient(180deg,#f8fafc,#fff)' }}>
                <div style={{ maxWidth: 1100, margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: 56 }}>
                        {!ownSystem && <span style={{ fontSize: 12, fontWeight: 700, color: '#2563eb', textTransform: 'uppercase', letterSpacing: '1.5px' }}>{t('contact.eyebrow')}</span>}
                        <h1 style={{ fontWeight: 800, fontSize: 36, color: '#0f172a', marginTop: 8, marginBottom: 16 }}>{t('contact.heroTitle')}</h1>
                        {!ownSystem && <p style={{ color: '#64748b', maxWidth: 480, margin: '0 auto', fontSize: 16 }}>
                            {t('contact.heroSubtitle')}
                        </p>}
                    </div>

                    <div className="row g-4 justify-content-center">
                        {[
                            // No fake phone/email/address card when it isn't actually set --
                            // a made-up number/address looks like real contact info to a visitor.
                            homepage?.phone && { icon: <MdPhone size={22} style={{ color: '#2563eb' }} />, label: t('contact.phoneLabel'), value: homepage.phone, sub: homepage?.hours || undefined },
                            homepage?.contact_email && { icon: <MdEmail size={22} style={{ color: '#22c55e' }} />, label: t('contact.emailLabel'), value: homepage.contact_email, sub: ownSystem ? undefined : t('contact.emailReplyTime') },
                            homepage?.address && { icon: <MdLocationOn size={22} style={{ color: '#f59e0b' }} />, label: t('contact.locationLabel'), value: homepage.address, sub: ownSystem ? undefined : t('contact.locationSubtitle') },
                        ].filter(Boolean).map(item => (
                            <div key={item.label} className="col-lg-4 col-md-6">
                                <div style={{ display: 'flex', gap: 16, padding: '20px', background: '#fff', borderRadius: 12, height: '100%', border: '1px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
                                    <div style={{ width: 48, height: 48, borderRadius: 10, background: '#f0f9ff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                                        {item.icon}
                                    </div>
                                    <div>
                                        <div style={{ fontWeight: 700, fontSize: 15, color: '#0f172a', marginBottom: 2 }}>{item.label}</div>
                                        <div style={{ fontSize: 14, color: '#374151', fontWeight: 500 }}>{item.value}</div>
                                        {item.sub && <div style={{ fontSize: 12, color: '#94a3b8' }}>{item.sub}</div>}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <footer style={{ background: '#0f172a', color: '#94a3b8', padding: '24px 5%', textAlign: 'center', fontSize: 13 }}>
                © {new Date().getFullYear()} {homepage?.system_name || 'MITI FMS'}. {t('contact.footerRights')}
            </footer>
        </div>
    );
}
